import { render, staticRenderFns } from "./overtime.vue?vue&type=template&id=540a438a&scoped=true"
import script from "./overtime.vue?vue&type=script&lang=js"
export * from "./overtime.vue?vue&type=script&lang=js"
import style0 from "./overtime.vue?vue&type=style&index=0&id=540a438a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a438a",
  null
  
)

export default component.exports